export default __webpack_public_path__ + "static/media/moon.dc6990fd.png";